<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue';
import './scss/Home.scss';
import Steps from './components/Steps.vue';
import Form from './components/FormHome.vue';
import Footer from './components/Footer.vue';
import WhatsappButton from './components/WhatsappButton.vue';
import getSubDomainInitial from '../../../helpers/getSubDomainInitial';
import { useI18n } from 'vue-i18n';
import { loadLocaleMessages } from '../../../helpers/lang/loadLocale';
import i18n from '../../../helpers/lang/i18n';
import LanguagesRepository from '@repositories/languages.repository';

// import CaptchaCloudflare from './components/CaptchaCloudflare.vue';

const { t, locale } = useI18n();
const subDomainInitial = ref<string>(getSubDomainInitial());

onMounted(async () => {
  const lang = await LanguagesRepository.getLanguageByUrlDomain(
    window.location.origin,
  );
  const locale = lang;
  const messages = loadLocaleMessages(locale);
  i18n.global.setLocaleMessage(locale, messages);
  i18n.global.locale.value = locale;
});

const perksList = computed(() => {
  locale.value;

  return [
    t('landing.home.sin_pagos_contratos'),
    t('landing.home.compra_online'),
    t('landing.home.seguridad_monitoreo'),
    t('landing.home.sin_deducibles'),
    t('landing.home.atencion_personalizada'),
  ];
});

// const onVerified = (token: string) => {
//   console.log('Captcha verified with token:', token);
// };
</script>

<template>
  <div class="landing">
    <!-- <h1>mi captch de test</h1>
    <CaptchaCloudflare
      site-key="0x4AAAAAACMhCL1Lpk0_s-sN"
      @verified="onVerified"
    /> -->

    <div class="landing__title">
      <h3 class="landing__cargoPass" v-if="subDomainInitial === 'CHILE'">
        {{ t('landing.home.cargopass') }}
      </h3>
      <h1 v-if="subDomainInitial !== 'CONTEMPORA'">
        {{ t('landing.home.seguro_de_mercancias_por_trayecto') }}
      </h1>
      <h1 v-else>{{ t('landing.home.seguro_carga_policy_client_chile') }}</h1>
    </div>
    <h2 class="landing__subtitle" v-if="subDomainInitial === 'SPAIN'">
      {{ t('landing.home.quieres_conocer_el_costo_de_tu_seguro') }}
    </h2>
    <h2 class="landing__subtitle" v-else>
      {{ t('landing.home.necesitas_saber_el_costo_de_tu_seguro_por_viaje') }}
    </h2>
    <h2 class="landing__subtitle">
      {{ t('landing.home.conoce_su_precio_en_menos_de_un_minuto') }}
    </h2>
    <div class="landing__container">
      <div class="landing__form-container">
        <div class="landing__info-perks">
          <h3 class="landing__perks-title">
            {{ t('landing.home.descubre_los_beneficios') }}
          </h3>
          <div
            v-for="perk in perksList"
            :key="perk"
            class="landing__perks-container"
          >
            <img src="/img/check.png" class="landing__perks-image" />
            <p class="landing__perks-text">{{ perk }}</p>
          </div>
          <h4 class="landing__perks-subtitle">
            {{ t('landing.home.precio_unico_por_cada_viaje') }}
          </h4>
        </div>
        <Form />
      </div>
      <Steps />
    </div>
    <Footer />
    <WhatsappButton />
  </div>
</template>
